import { Editor } from 'grapesjs';
import {
  LEADERBOARD_ABOVE_DEFAULT_LIMIT,
  LEADERBOARD_BELOW_DEFAULT_LIMIT,
  LEADERBOARD_TOP_DEFAULT_LIMIT,
} from '@loyalty/shared-common/leaderboard-api-client';
import { LeaderboardV2TableRenderer } from '@loyalty/editor-components';
import { faUsersCrown } from '@fortawesome/pro-solid-svg-icons/faUsersCrown';
import { EditorComponentDefinition } from '../types';
import { EditorContext } from '../../../services/editor-service';
import { LeaderboardV2TableWidgetTraits } from './LeaderboardV2TableWidgetTraits';
import { Toolbar, buildParticipantContextFromGrape } from '../../utils';

const CLASSNAME = 'qlfeditor-leaderboard__table';

export const leaderboardV2TableComponentDefinition: EditorComponentDefinition = {
  id: 'leaderboard-v2-table',
  icon: faUsersCrown,
  getLabel: ({ t }) => t('editor.component.leaderboard'),
  traits: {
    form: LeaderboardV2TableWidgetTraits,
  },
  component: LeaderboardTableGrapesComponent,
  copyPasteHelper: (element, context) => {
    element.attributes.currencyId = context.defaultCurrencyId;
  },
};

export function LeaderboardTableGrapesComponent(editor: Editor) {
  const i18n = editor.I18n;
  const context: EditorContext = editor.Config.context;
  const currencies = context.currencies;

  editor.DomComponents.addType(leaderboardV2TableComponentDefinition.id, {
    isComponent(el: HTMLElement) {
      return el.tagName === 'DIV' && el.classList.contains(CLASSNAME);
    },
    model: {
      defaults: {
        tagName: 'div',
        attributes: {
          showProfilePicture: true,
          showProfileName: true,
          profileNameFormat: 'fullname',
          currencyId: `${currencies[0]?.id}`,
          class: 'qlfeditor-leaderboard-table',
          topLimit: LEADERBOARD_TOP_DEFAULT_LIMIT.toString(),
          aboveLimit: LEADERBOARD_ABOVE_DEFAULT_LIMIT.toString(),
          belowLimit: LEADERBOARD_BELOW_DEFAULT_LIMIT.toString(),
        },
        name: 'leaderboard-table',
        content: '',
        droppable: false,
        draggable: false,
        removable: false,
        copyable: false,
        traits: [],
      },
      initToolbar: Toolbar,
      init() {
        this.on('change:attributes', this.handleChange);
      },
      handleChange() {
        this.refresh();
      },
      refresh() {
        setTimeout(() => this.view?.onRender());
      },
      toHTML(): string {
        return LeaderboardV2TableRenderer(
          {
            state: context.widgetState,
            options: {
              id: this.getId(),
              attributes: this.getAttributes(),
              i18nAttributes: this.attributes.i18nAttributes || {},
            },
            context: buildParticipantContextFromGrape(i18n),
          },
          editor.Canvas.getDocument(),
        );
      },
    },
    view: {
      onRender() {
        const { el, model } = this;
        el.innerHTML = model.toHTML();
      },
    },
  });
}
